import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const CommunityGuidelinesPage: React.FC = () => (
  <LegalPageLayout title="Community Guidelines" updated="August 14, 2026">
    <p>Bilt is for documenting real cars and real work. These guidelines apply to builds, clubs, shops, events, Passport, and media.</p>
    <h2>Be accurate</h2>
    <p>Describe parts and work honestly. Do not invent shops, awards, or contributor credit.</p>
    <h2>Be respectful</h2>
    <p>No harassment, hate, threats, or sexual content involving minors. Report abuse from in-product tools where available.</p>
    <h2>Respect intellectual property</h2>
    <p>Only upload media and logos you have rights to use. Copyright complaints: see Copyright / DMCA.</p>
    <h2>No fraud</h2>
    <p>Do not fake check-ins, Passport scans, payments, shop claims, or sponsorship eligibility.</p>
    <h2>Enforcement</h2>
    <p>We may remove content, restrict features, or suspend accounts. Appeals can be sent to support through privacy/support channels.</p>
  </LegalPageLayout>
);

export default CommunityGuidelinesPage;
